import { CalendarPlanBlockClientData } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CONTENT_TYPE } from '@yandex-int/k-common/typings/api/models/content';
import cx from 'classnames';
import React from 'react';

import { ShowcaseMetrikaParams } from 'common.components/typings';
import { ActualContentActivity } from 'common.components/widgets.actual-content/__activity/actual-content__activity';
import { useLessonAssignment } from 'common.components/widgets.actual-content/use-lesson-assignment';

import './actual-content__activities-list.scss';

interface Props {
    block: CalendarPlanBlockClientData;
    mix?: string;
    metrikaParams?: ShowcaseMetrikaParams;
}

export const ActualContentActivitiesList = (props: Props) => {
    const { block, mix, metrikaParams } = props;
    const { activities: items, slug: subject } = block;

    const lessonAssignmentLoadingStatus = useLessonAssignment(subject, items);

    return (
        <div className={cx('actual-content__item-activities-list', mix)}>
            {items.map((activity) => {
                const isLesson = activity.content_type === CONTENT_TYPE.LESSON;
                const isLoading = isLesson && lessonAssignmentLoadingStatus === LOADING_STATUSES.LOADING;
                const description = activity.content_additional_info?.name;

                return (
                    <ActualContentActivity
                        additionalInfo={activity.additional_info}
                        contentId={activity.content_id}
                        contentType={activity.content_type}
                        description={description}
                        isLoading={isLoading}
                        key={activity.content_id}
                        metrikaParams={metrikaParams}
                        subject={subject}
                        viewSettings={activity.activity_view_settings}
                    />
                );
            })}
        </div>
    );
};
